import React, { useEffect } from 'react';

import type { ResultType } from '../../../constants/global';
import { useGlobalContext } from '../../../context/global';
import { Hvc } from '../../utils/hooks';
import ChildCodesStage from './child-codes';
import PartyVotes from './party-votes';
import PartyVotesStageCTA from './party-votes-stage-cta';

export const getResultCodeTitle = (resultType: ResultType) => {
	switch (resultType) {
		case 'EC8B':
			return { parent: 'Ward', child: 'Polling Unit' };
		case 'EC8C':
			return { parent: 'LGA', child: 'Ward' };
		case 'EC8D':
			return { parent: 'State', child: 'LGA' };
		default:
			return { parent: '', child: '' };
	}
};

const PartyVotesStage = () => {
	const {
		global: {
			state: { isPreview: preview, partyVoteStage, childCodes, resultType, partyVoteDeepLink },
			updateState,
		},
		onStage,
	} = useGlobalContext();

	const isCode = resultType !== 'EC8A';

	useEffect(() => {
		// A caller outside this stage (e.g. the vote-balance ledger) can ask for a
		// specific child's grid. Honour that instead of resetting to the child list,
		// and consume the flag so a later plain entry still lands on the list.
		if (isCode && partyVoteDeepLink) {
			updateState('partyVoteStage', 'Party Votes');
			updateState('partyVoteDeepLink', false);
			return;
		}
		updateState('partyVoteStage', isCode ? 'Child' : 'Party Votes');
	}, []);

	const isDone = childCodes.some((i) => i.status);

	const onDone = () => {
		onStage('Preview');
	};

	const isUpdate = false;

	return (
		<div className='f-column-33'>
			<Hvc
				removeDOM
				view={partyVoteStage === 'Child'}
				className='f-column-33'
			>
				<ChildCodesStage />
				<PartyVotesStageCTA
					isDone={isDone}
					onDone={onDone}
					preview={preview}
					onStage={onStage}
					isUpdate={isUpdate}
				/>
			</Hvc>
			<Hvc
				removeDOM
				view={partyVoteStage === 'Party Votes'}
				className='f-column-33'
			>
				<PartyVotes />
			</Hvc>
		</div>
	);
};

export default PartyVotesStage;
